import { z } from 'zod';

import {
  BBAN_BANK_CODE_REGEX,
  BBAN_BRANCH_CODE_REGEX,
  BBAN_ACCOUNT_NUMBER_REGEX,
} from 'lib/bban';

const common = {
  name: z.string().min(1, 'input.required'),
  // PSU ID: digits only, 5–9 characters. Shorter values are left-padded to 9
  // digits at submit time (see helpers `toPayload`).
  psuId: z
    .string()
    .min(1, 'input.required')
    .regex(/^\d{5,9}$/, 'validation.psuId'),
  glBankAccountId: z.string().min(1, 'input.required'),
  providerId: z.string().min(1, 'input.required'),
};

// The account is entered as 3 parts (bank code / branch code / account number),
// zero-padded to their fixed widths (3/3/13) and assembled into an Israeli IBAN
// ('IL' + mod-97 check digits + BBAN) at submit time (see lib/iban).
const accountParts = {
  bankCode: z.string().regex(BBAN_BANK_CODE_REGEX, 'validation.bankCode'),
  branchCode: z.string().regex(BBAN_BRANCH_CODE_REGEX, 'validation.branchCode'),
  accountNumber: z.string().regex(BBAN_ACCOUNT_NUMBER_REGEX, 'validation.bbanAccountNumber'),
};

export const openFinanceSchema = z.object({
  ...common,
  ...accountParts,
});

// Flat shape for react-hook-form defaultValues.
export interface OpenFinanceFormShape {
  name: string;
  psuId: string;
  glBankAccountId: string;
  providerId: string;
  bankCode: string;
  branchCode: string;
  accountNumber: string;
}
